import { TextInput } from '@jfs/ui-new'
import { SpacerNew } from '@jfs/ui-new/src/comps/SpacerNew'
import { ConsentCheckbox } from '../../comps/ConsentCheckbox'
import { forgotPwdStrings, staticStrings } from '../../data/static/strings'
import { testProps } from '../../util/util'
import { mobileNumber } from '../../util/validations'

export const formData = (leftComponent: any): any => [
  {
    formItems: [
      {
        fieldName: 'mobileNumber',
        ComponentName: TextInput,
        // type: TextInputType.FORGOT_PWD_MOBILE, //TODO: handle this as per design in TextInput
        label: staticStrings.signUpPhone,
        validationSchema: mobileNumber,
        maxLength: 10,
        inputMode: 'numeric',
        autoFocus: true,
        returnKeyType: 'done',
        leftComponent: leftComponent(),
        ...testProps('signup-mobile-input'),
      },
      {
        fieldName: 'spacer',
        ComponentName: SpacerNew,
        size: 2,
        ...testProps('spacer-sign-up'),
      },
      {
        fieldName: 'consentCheckbox',
        ComponentName: ConsentCheckbox,
        ...testProps('consent-checkbox-terms-condition'),
      },
    ],
    onSubmit: () => {
      return 'end'
    },
  },
]
export const pwdStrengthCbData = [
  {
    id: '1',
    value: forgotPwdStrings.eightCharacters,
  },
  {
    id: '2',
    value: forgotPwdStrings.oneLowerCaseLetter,
  },
  {
    id: '3',
    value: forgotPwdStrings.oneCapitalLetter,
  },
  {
    id: '4',
    value: forgotPwdStrings.oneSpecialCharacter,
  },
  {
    id: '5',
    value: forgotPwdStrings.oneDigit,
  },
]
